export default __webpack_public_path__ + "static/media/location-gray.7a46091d.svg";